import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  admins: [],
  fetchLoading: false,
  singleAdmin: null,
};

const slice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateAdminSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getAdminSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.admins = action.payload;
    },

    getSingleAdminSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleAdmin = action.payload;
    },

    // GET PRODUCTS
    createAdminSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // DELETE EVENT
    deleteAdminSuccess(state, action) {
      const adminId = action.payload;
      state.admins.data = state.admins.data.filter(
        (admin) => admin.id !== adminId
      );
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getAdmins() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("users", {
        params: {
          filterBy: "admin",
        },
      });

      dispatch(
        slice.actions.getAdminSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleAdmin({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`users/${id}`);
      dispatch(slice.actions.getSingleAdminSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createAdmin({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post("register", data);
      dispatch(slice.actions.createAdminSuccess());
      enqueueSnackbar("User is added successfully");
      navigate(PATH_DASHBOARD.admins.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateAdmin({ id, data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.put(`users/${id}`, data);
      dispatch(slice.actions.updateAdminSuccess());
      enqueueSnackbar("User is updated successfully");
      navigate && navigate(PATH_DASHBOARD.admins.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteAdmin({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`users/${id}`);
      dispatch(slice.actions.deleteAdminSuccess(id));
      enqueueSnackbar("User is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
